const ItemQueryFields = [
    {
        name: '#',
        code: '_seq_',
        column: true,
        sortable: false,
        defaultFilter: false,
        width: 60
    },
    {
        name: 'Po',
        code: 'po',
        column: true,
        sortable: true,
        align: 'center',
        defaultFilter: true,
        listFilter: true,
        width: 150
    },
    {
        name: 'Style',
        code: 'style',
        column: true,
        sortable: true,
        defaultFilter: true,
        listFilter: true,
        align: 'center',
        width: 150
    },
    {
        name: 'Color',
        code: 'color',
        column: true,
        defaultFilter: false,
        listFilter: false,
        sortable: true,
        align: 'center',
        width: 100
    },
    {
        name: 'Lotti',
        code: 'lotti',
        column: true,
        defaultFilter: false,
        listFilter: false,
        sortable: true,
        align: 'center',
        width: 150
    },
    {
        name: 'total',
        code: 'total',
        column: true,
        sortable: true,
        align: 'left',
        width: 100
    },
    {
        name: 'barcode',
        code: 'barcode',
        column: true,
        sortable: true,
        align: 'center',
        width: 120
    },
    {
        name: 'size',
        code: 'sizeSummary',
        column: true,
        sortable: true,
        align: 'center'
    },
];
export default ItemQueryFields;
